import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { DefaultPopover, Row, Col, Label, FormGroup, Separator, InputGroup, InputGroupText, Checkbox, Input as InputPure, Button } from 'twyne-new.ui'

import Select from 'components/form/Select';
import SwitchCustom from 'components/form/SwitchCustom';

export default function Form({ index, data, name, options, onAdd, onChange, onRemove, toggle, setToggle }) {
  const [id, setId] = useState('')
  const [overrideConversion, setOverrideConversion] = useState(false)
  const [conversionStep, setConversionStep] = useState(null)
  const [weight, setWeight] = useState(1)
  const [active, setActive] = useState(true)
  const [stepsOptions, setStepsOptions] = useState([])

  const { id: _id } = data || {}
  const disabled = !id || (overrideConversion && !conversionStep)

  useEffect(() => {
    if (_id && toggle) {
      setId(_id)
      setOverrideConversion(data.override_conversion)
      setConversionStep(data.conversion_step)
      setWeight(data.weight)
      setActive(data.active)
    }
  }, [_id, toggle, data])

  useEffect(() => {
    if (id) {
      const option = options?.find(option => option.value === id)
      const steps = option ? option.steps : 0
      setStepsOptions([...Array(steps)].map((_, i) => ({ value: i + 1, label: i + 1 })))
    } else {
      setOverrideConversion(false)
      setConversionStep('')
    }
  }, [id, options])

  useEffect(() => {
    if (!overrideConversion) setConversionStep(null)
  }, [overrideConversion])

  const handleApply = () => {
    const form = {
      id, weight, active,
      override_conversion: overrideConversion, conversion_step: conversionStep,
    }
    onChange ? onChange(index, form) : onAdd(form)
    handleClose()
  }

  const handleRemove = () => {
    onRemove(index)
    handleClose()
  }

  const handleClose = () => {
    setToggle(false)
    setId('')
    setOverrideConversion(false)
    setConversionStep(null)
    setWeight(1)
    setActive(true)
  }

  const handleChangeForm = option => {
    const { value: id } = option
    setId(id)
  }

  return <DefaultPopover
    trigger={<span></span>}
    wrapperProps={{ open: toggle, onOpenChange: handleClose }}
  >

    {_id ? <>
      Edit <Link to={`/offer/forms/${_id}/fields`} target='_blank'>
        [#{_id}] {name}
      </Link>
    </> : 'Add Form'}

    <Separator className='my-2' />

    <Row>
      <Col size="12">
        <FormGroup>
          <Label>Form</Label>
          <Select
            name="_"
            value={id}
            options={options}
            handleOnChange={handleChangeForm}
            clearable={false}
          />
        </FormGroup>
      </Col>
      <Col size="12">
        <FormGroup>
          <Label>Override Form Conversion</Label>
          <InputGroup>
            <InputGroupText addonType='prepend'>
              <Checkbox
                onChange={checked => setOverrideConversion(checked)}
                value={overrideConversion}
              />
            </InputGroupText>
            <Select
              name="_"
              value={conversionStep}
              options={stepsOptions}
              clearable={false}
              handleOnChange={option => setConversionStep(option.value)}
              disabled={!overrideConversion}
            />
          </InputGroup>
        </FormGroup>
      </Col>
      <Col size="12">
        <FormGroup>
          <Label>Weight</Label>
          <InputPure
            type="number"
            value={weight}
            onChange={event => setWeight(parseInt(event.target.value))}
            min={1}
          />
        </FormGroup>
      </Col>
      <Col size="2">
        <FormGroup>
          <Label>Active</Label>
          <SwitchCustom
            name="_"
            value={active}
            handleOnChange={e => setActive(e.target.checked)}
          />
        </FormGroup>
      </Col>
      <Col size='12' className='flex gap-2'>
        <Button block color="accent" size='sm' onClick={handleApply} disabled={disabled}>
          Apply
        </Button>
        {onRemove ? <Button color="danger" block size='sm' variant='ghost' onClick={handleRemove}>
          Remove
        </Button> : null}
      </Col>
    </Row>
  </DefaultPopover>
}
